import { render, staticRenderFns } from "./UIReadonlyField.vue?vue&type=template&id=3fac9f18"
import script from "./UIReadonlyField.vue?vue&type=script&lang=js"
export * from "./UIReadonlyField.vue?vue&type=script&lang=js"
import style0 from "./UIReadonlyField.vue?vue&type=style&index=0&id=3fac9f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports